export default "__VITE_ASSET__DxOz8wO1__"